import { queryOptions } from "@tanstack/react-query";
import { fetchMetricsPortfolio } from "./metrics.api";

/**
 * React Query wiring for the Metrics Dashboard, following insights-home's
 * `*.queries.ts` shape (a `queryKeys` object + a `queryOptions` factory).
 * Components call `useQuery(metricsPortfolioQueryOptions())`; the queryFn is
 * the only thing that changes when the real endpoint lands (see metrics.api.ts).
 */

export const metricsQueryKeys = {
  all: ["metrics"] as const,
  portfolio: () => [...metricsQueryKeys.all, "portfolio"] as const,
};

/** Portfolio changes slowly; 5 minutes before a background refetch. */
const PORTFOLIO_STALE_TIME_MS = 5 * 60 * 1000;

export function metricsPortfolioQueryOptions() {
  return queryOptions({
    queryKey: metricsQueryKeys.portfolio(),
    queryFn: fetchMetricsPortfolio,
    staleTime: PORTFOLIO_STALE_TIME_MS,
  });
}
